/**
 * BrewNectar Sound Familiar — scroll-triggered fade-up animations
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initSection(section) {
    if (!section || section.dataset.bnSfInit === 'true') return;
    section.dataset.bnSfInit = 'true';

    var animated = section.querySelectorAll('.bn-sf__animate');

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '-60px 0px', threshold: 0 }
    );

    animated.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bn-sf-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-bn-sf-section]') || e.target;
    if (section.matches && section.matches('[data-bn-sf-section]')) {
      section.dataset.bnSfInit = '';
      initSection(section);
    }
  });
})();
